export default {
  bold: 'Negrita',
  italic: 'Cursiva',
  underline: 'Subrayado',
  insertUnorderedList: 'Lista con viñetas',
  insertOrderedList: 'Lista numerada'
}
